module.exports = __webpack_public_path__ + "font_genshin_son.0e324920.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_genshin_son.png
// module id = DmHZ
// module chunks = 0